import React from 'react';
import './OrderItemSummary.scss';
import { Divider } from 'antd';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  code: string;
  price: number;
}

const DiscountItem: React.SFC<IProps> = ({ 
  code = '',
  price = 0, 
}) => (
  <>
    <div className='summary-item'>
      <div className='name-container'>
        <FormattedText 
          style='medium-bold sub-title'
          displayName='Presentkort'
          formattedName='voucher.header'
        />
        <span>{ code }</span>
      </div>
      <div className='quantity-container'>
          <span>1</span>
      </div>
      <div className='total-price-container'>
        <span className='medium-bold'>- </span>
        <PriceItem 
          style='medium-bold' 
          price={ price } 
          decimals={ 2 }
        />
      </div>
    </div>
    <Divider />
  </>
);

export default DiscountItem;


// WEBPACK FOOTER //
// ./src/components/OrderItemSummary/DiscountItem.tsx